import ReadingFillInTheBlankQuesiton from '../../components/ReadingCourse/ReadingFillInTheBlankQuestion'

const ReadingFillInTheBlank = () => {
  return <ReadingFillInTheBlankQuesiton />
}

export default ReadingFillInTheBlank
